export var valuesPlaylistEdgeTransitionFunction = ["FallThru", "PercentageDone", "AbsCountDone", "ReferenceDone", "ReferenceDoneWithValue", "ReferenceDoneWithValueBetween", "TrainerAction", "TrainerActionWithValue"];
/*

*/ 
//# sourceMappingURL=PlaylistEdgeTransitionFunction.js.map